import { TargetCondition, TargetKeyType } from "../../model/model"
import ValueOperatorMatcher from "./ValueOperatorMatcher"
import { OperatorMatcherFactory } from "./OperatorMatcher"
import { ValueMatcherFactory } from "./ValueMatcher"
import Evaluator, { EvaluatorContext, EvaluatorRequest } from "../evalautor/Evaluator"
import UserConditionMatcher, { UserValueResolver } from "./UserConditionMatcher"
import SegmentConditionMatcher, { SegmentMatcher } from "./SegmentConditionMatcher"
import ExperimentConditionMatcher, {
  AbTestConditionMatcher,
  FeatureFlagConditionMatcher
} from "./ExperimentConditionMatcher"

export default interface ConditionMatcher {
  matches(request: EvaluatorRequest, context: EvaluatorContext, condition: TargetCondition): boolean
}

export class ConditionMatcherFactory {
  private readonly userConditionMatcher: ConditionMatcher
  private readonly segmentConditionMatcher: ConditionMatcher
  private readonly experimentConditionMatcher: ConditionMatcher

  constructor(evaluator: Evaluator) {
    const valueOperatorMatcher = new ValueOperatorMatcher(new ValueMatcherFactory(), new OperatorMatcherFactory())
    const userConditionMatcher = new UserConditionMatcher(new UserValueResolver(), valueOperatorMatcher)
    this.userConditionMatcher = userConditionMatcher
    this.segmentConditionMatcher = new SegmentConditionMatcher(new SegmentMatcher(userConditionMatcher))
    this.experimentConditionMatcher = new ExperimentConditionMatcher(
      new AbTestConditionMatcher(evaluator, valueOperatorMatcher),
      new FeatureFlagConditionMatcher(evaluator, valueOperatorMatcher)
    )
  }

  getMatcher(type: TargetKeyType): ConditionMatcher {
    switch (type) {
      case "USER_ID":
      case "USER_PROPERTY":
      case "HACKLE_PROPERTY":
        return this.userConditionMatcher
      case "SEGMENT":
        return this.segmentConditionMatcher
      case "AB_TEST":
      case "FEATURE_FLAG":
        return this.experimentConditionMatcher
      case "EVENT_PROPERTY":
        throw new Error(`Unsupported TargetKeyType [${type}]`)
    }
  }
}
